import CreditCardFilled from 'svg/CreditCardFilled';
import DollarSign from 'svg/DollarPlain';
import classNames from 'styles/utils/classNames';

interface Props {
  selected: 'card' | 'at_event';
  onSelectCard: () => void;
  onSelectPayAtEvent: () => void;
}

const selectedStyles =
  'border-0 bg-color-bg-lightmode-primary shadow-[0_0_0_2px_#fff,0_0_0_3px_#b9b9be,0_4px_20px_0_rgba(0,0,0,0.16)]  dark:bg-color-bg-darkmode-primary dark:shadow-[0_0_0_2px_#18181b,0_0_0_3px_#3f3f46,0_4px_20px_0_rgba(0,0,0,0.3)]';
const unselectedStyles =
  'cursor-pointer border-color-border-card-lightmode dark:border-color-border-card-darkmode hover:border-color-text-lightmode-secondary dark:hover:border-color-text-darkmode-secondary';

export default function PaymentMethodSelector({
  selected,
  onSelectCard,
  onSelectPayAtEvent,
}: Props) {
  return (
    <>
      <div className="mb-6 grid grid-cols-2 gap-3">
        <button
          type="button"
          onClick={onSelectCard}
          className={classNames(
            'relative flex flex-col rounded-lg border px-4 py-3 text-left transition-colors',
            selected === 'card' ? selectedStyles : unselectedStyles,
          )}
        >
          <CreditCardFilled className="mb-2 h-5 w-5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary" />
          <span className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Card
          </span>
          <span
            className={classNames(
              'absolute right-3 top-3 flex h-4 w-4 items-center justify-center rounded-full border-2',
              selected === 'card'
                ? 'border-color-text-lightmode-primary bg-color-text-lightmode-primary dark:border-color-text-darkmode-primary dark:bg-color-text-darkmode-primary'
                : 'border-color-border-input-lightmode dark:border-color-border-input-darkmode',
            )}
            aria-hidden="true"
          >
            {selected === 'card' && (
              <span className="h-1.5 w-1.5 rounded-full bg-color-bg-lightmode-primary dark:bg-color-bg-darkmode-primary" />
            )}
          </span>
        </button>
        <button
          type="button"
          onClick={onSelectPayAtEvent}
          className={classNames(
            'relative flex flex-col rounded-lg border px-4 py-3 text-left transition-colors',
            selected === 'at_event' ? selectedStyles : unselectedStyles,
          )}
        >
          <DollarSign className="mb-2 h-5 w-5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary" />
          <span className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Pay at event
          </span>
          <span
            className={classNames(
              'absolute right-3 top-3 flex h-4 w-4 items-center justify-center rounded-full border-2',
              selected === 'at_event'
                ? 'border-color-text-lightmode-primary bg-color-text-lightmode-primary dark:border-color-text-darkmode-primary dark:bg-color-text-darkmode-primary'
                : 'border-color-border-input-lightmode dark:border-color-border-input-darkmode',
            )}
            aria-hidden="true"
          >
            {selected === 'at_event' && (
              <span className="h-1.5 w-1.5 rounded-full bg-color-bg-lightmode-primary dark:bg-color-bg-darkmode-primary" />
            )}
          </span>
        </button>
      </div>
    </>
  );
}
